module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentPrice > -1) ? _c('div', {
    staticClass: "kj-pro-now_price"
  }, [(_vm.currentPriceAvatar) ? _c('img', {
    staticClass: "kj-pro-now_price_avator",
    attrs: {
      "src": _vm.currentPriceAvatar
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "kj-pro-now_price_cont"
  }, [_vm._v("当前价格 ￥" + _vm._s((_vm.currentPrice / 100).toFixed(2)))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ec1a974","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bargainDetail/subpage/currentPrice.vue
// module id = 293
// module chunks = 0